module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9JpV2"))).then(() => parcelRequire('d0iPb'));